import "./Leadership.module.css";
import Header from "@/reusable_sections/Header";
import LeadershipIntroduction from "./sections/LeadershipIntroduction";
import ExecutiveProfiles from "./sections/ExecutiveProfiles";
import ExecutiveProfilesCopy from "./sections/ExecutiveProfilesCopy";
import WhatYourFreeHiveReportShows from "./sections/WhatYourFreeHiveReportShows";
import Footer from "@/reusable_sections/Footer";
export default function LeadershipPage() {
  return <div>
      <Header />
      <LeadershipIntroduction />
      <ExecutiveProfiles />
      <ExecutiveProfilesCopy />
      <WhatYourFreeHiveReportShows />
      <Footer />
    </div>;
}